export default {
    vidfleet_configuration_title_bulk: "VidFleet Bulk Config Settings",
    vidfleet_configuration_imei: "IMEI",
    vidfleet_configuration_manufacturer: "Manufacturer",
    vidfleet_configuration_model: "Model",
    vidfleet_configuration_esn: "Serial",
    vidfleet_configuration_device_search_criteria: "Serial",
    vidfleet_configuration_device_add: "Add",
    vidfleet_configuration_device_not_supported: "There are devices with manufacturers not supported",
    vidfleet_configuration_sent: "Sent",
    vidfleet_configuration_only_vidfleet: "Is not a VidFleet device",
    vidfleet_configuration_only_same_model: "Is not the same model",

    vidfleet_configuration_apply_scopes: "Apply Scopes",
    vidfleet_configuration_apply_scopes_default: "Default",
    vidfleet_configuration_apply_scopes_all: "All",
    vidfleet_configuration_apply_scopes_partial: "Partial",

    vidfleet_configuration_apply_scopes_default_message: 'This change will be applied as "DEFAULT" for "ALL" new devices added to PLATFORM',
    vidfleet_configuration_apply_scopes_all_message: 'This change will be applied for "ALL" existing devices on the PLATFORM',
    vidfleet_configuration_apply_scopes_partial_message: "Only the cameras listed below will take the configuration",
    vidfleet_configuration_apply_scopes_partial_message_2: "Only the cameras selected on the first step below will take the configuration",

    vidfleet_configuration_apply_settings: "Apply settings",
    vidfleet_configuration_apply_settings_to: "Apply settings to",
    vidfleet_configuration_apply_settings_to_devices: "devices",

    vidfleet_configuration_change_vidfleet_configuration: "Change VidFleet Configuration",

    vidfleet_configuration_new_config: "New Configuration",
    vidfleet_configuration_reset_all_config_to_default: "Reset all configuration options to default",
    vidfleet_configuration_sounds_reset_to_default: "Sounds options reset to default",
    vidfleet_configuration_new_sound_option: "New sound options added",
    vidfleet_configuration_adas_sounds: "ADAS Sounds",

    vidfleet_configuration_event_threshold_reset_to_default: "Events & Thresholds options reset to default",

    vidfleet_configuration_add_more_devices: "Add more devices",

    vidfleet_configuration_clone_settings: "Clone Settings",
    vidfleet_configuration_choose_manually: "Choose Manually",
    vidfleet_configuration_select_device_message: "Enter Camera's ESN to clone configuration",
    vidfleet_configuration_search_vidfleet_device: "Search a VidFleet Device by Nametag or Camera ID",
    vidfleet_configuration_select_device_message_different_model: "There are devices with differents models, it is necessary that all the devices have the same device model",
    vidfleet_configuration_rewrite_config_message: "The configuration selected is going to overwrite all the configuration on the devices selected, do you want to continue?",
    vidfleet_configuration_save_error: "There was an error saving the configuration",

    //from tab
    vidfleet_configuration_title: "VidFleet Default Config",

    vidfleet_configuration_save_changes: "Save Changes",

    vidfleet_configuration_sounds: "Sounds",
    vidfleet_configuration_power: "Power",
    vidfleet_configuration_event_trigger: "Event Trigger",
    vidfleet_configuration_recording: "Recording",

    vidfleet_configuration_event_threshold: "Event Threshold Settings",
    vidfleet_configuration_acc_value: "Acc Value",
    vidfleet_configuration_brake_value: "Brake Value",
    vidfleet_configuration_turn_value: "Turn Value",

    vidfleet_configuration_acc_step0: "Acc Step0",
    vidfleet_configuration_brake_step0: "Brake Step0",
    vidfleet_configuration_turn_step0: "Turn Step0",

    vidfleet_configuration_acc_step1: "Acc Step1",
    vidfleet_configuration_brake_step1: "Break Step1",
    vidfleet_configuration_turn_step1: "Turn Step1",

    vidfleet_configuration_acc_duration: "Acc Duration",
    vidfleet_configuration_brake_duration: "Brake Duration",
    vidfleet_configuration_turn_duration: "Turn Duration",
    vidfleet_configuration_min_value: "The minimum value for this field must be 0",

    vidfleet_configuration_event_level: "Event Level",
    vidfleet_configuration_hard_accel: "Hard Acceleration",
    vidfleet_configuration_hard_break: "Hard Break",
    vidfleet_configuration_sharp_turn: "Sharp Turn",
    vidfleet_configuration_driving_hit: "Driving Hit",
    vidfleet_configuration_power_lost: "Power Off",
    vidfleet_configuration_potential_incident: "Potential Incident",
    vidfleet_configuration_parking_hit: "Parking Hit",

    vidfleet_configuration_video_streams: "Video Streams",
    vidfleet_configuration_stream0: "Stream 0",
    vidfleet_configuration_stream1: "Stream 1",
    vidfleet_configuration_quality: "Quality",

    vidfleet_configuration_delayed_power_off: "Delayed Power Off",
    vidfleet_configuration_seconds: "s",
    vidfleet_configuration_minutes: "min",
    vidfleet_configuration_milli_g: "mg",
    vidfleet_configuration_km_h: "km/h",
    vidfleet_configuration_10_s: "1/10s",
    vidfleet_configuration_milli_volts: "mV",

    vidfleet_configuration_mic: "Microphone",
    vidfleet_configuration_auto_snapshot: "Auto Snapshot",
    vidfleet_configuration_interval: "Interval",

    vidfleet_configuration_live_stream_duration: "Live Stream Duration",

    vidfleet_configuration_marked_clip_duration: "Marked Clip Duration",

    vidfleet_configuration_acceleration: "Acceleration",
    vidfleet_configuration_manual: "Manual",
    vidfleet_configuration_dms: "DMS",
    vidfleet_configuration_before: "Before",
    vidfleet_configuration_after: "After",

    vidfleet_configuration_privacy_mask: "Privacy Mask",

    vidfleet_configuration_load_error: "There was a error loading the configuration",
    vidfleet_configuration_save_success: "Configuration saved successfully",
    vidfleet_configuration_save_error: "The configuration could not be saved",

    vidfleet_configuration_dms_sounds: "DMS Sound (Secure4K Only)",
    vidfleet_configuration_using_phone: "Using Phone",
    vidfleet_configuration_attentive: "Attentive",
    vidfleet_configuration_smoking: "Smoking",
    vidfleet_configuration_drowsiness: "Drowsiness",
    vidfleet_configuration_no_seatbelt: "No Seatbelt",
    vidfleet_configuration_no_driver: "No Driver",
    vidfleet_configuration_daydreaming: "Daydreaming",
    vidfleet_configuration_yawn: "Yawn",
    vidfleet_configuration_asleep: "Asleep",
    vidfleet_configuration_distracted: "Distracted",

    vidfleet_configuration_min_speed: "Minimum Speed",
    vidfleet_configuration_detection_delay: "Detection Delay",
    vidfleet_configuration_repeat_interval: "Repeat Interval",
    vidfleet_configuration_detection_reset: "Detection Reset",
    vidfleet_configuration_max_speed: "Maximum Speed",
    vidfleet_configuration_over_speed_limit: "Over Speed Limit",

    vidfleet_configuration_video_stream_360: "Video Stream (Secure360 SecureES)",
    vidfleet_configuration_video_stream_4k: "Video Resolution",
    vidfleet_configuration_high_bit_rate: "High bit rate",
    vidfleet_configuration_low_bit_rate: "Low bit rate",
    vidfleet_configuration_video_resolution: "Video Resolution",

    vidfleet_configuration_other_settings: "Other configurations",

    vidfleet_configuration_default: "Default",
    vidfleet_configuration_custom: "Custom",

    vidfleet_configuration_event_thresholds_levels: "Event & Thresholds",

    vidfleet_configuration_vehicle_class_present: "Vehicle Class Preset",

    vidfleet_configuration_heavy_duty: "Heavy Duty",
    vidfleet_configuration_light_truck: "Light Truck (pickup, SUV)",
    vidfleet_configuration_sedan: "Sedan",

    vidfleet_configuration_thresholds: "Thresholds",
    vidfleet_configuration_levels: "Levels",

    vidfleet_configuration_super_low: "Super Low",
    vidfleet_configuration_low: "Low",
    vidfleet_configuration_med: "Med",
    vidfleet_configuration_high: "High",
    vidfleet_configuration_heavy: "Heavy",
    vidfleet_configuration_off: "Off",
    vidfleet_configuration_normal: "Normal",
    vidfleet_configuration_main: "Main",
    vidfleet_configuration_super: "Super",
    vidfleet_configuration_upside_down: "Upside down",

    vidfleet_configuration_camera_orientation: "Camera Orientation",
    vidfleet_configuration_rotate: "Rotate",

    vidfleet_configuration_trust_acc: "ECM Voltage Data (trustAcc)",
    vidfleet_configuration_night_vision: "Night Vision",
    vidfleet_configuration_driving_night_vision: "Driving Night Vision",
    vidfleet_configuration_from: "From",
    vidfleet_configuration_to: "To",
    vidfleet_configuration_obdii: "OBD_II",
    vidfleet_configuration_obdii_mode: "Mode",
    vidfleet_configuration_voltage: "Voltage",
    vidfleet_configuration_voltage_on: "Ignition On",
    vidfleet_configuration_voltage_off: "Ignition Off",
    vidfleet_configuration_voltage_check: "Check",
    vidfleet_configuration_volume: "Volume",
    vidfleet_configuration_volume_level: "Level",
    vidfleet_configuration_driving_night_vision_on: "On",
    vidfleet_configuration_driving_night_vision_auto: "Auto",
    vidfleet_configuration_driving_night_vision_off: "Off",

    vidfleet_configuration_vidfleet_config_save_accepted: "Configuration accepted by the device",
    vidfleet_configuration_vidfleet_config_sent: "Configuration sent to the device",

    vidfleet_configuration_cancel: "Cancel",

    vidfleet_configuration_expand_all: "Expand All",
    vidfleet_configuration_collapse_all: "Collapse All",
    vidfleet_configuration_restore_all: "Restore all to Default",

    vidfleet_configuration_dms_events: "DMS Events",

    vidfleet_configuration_events: "Events",

    vidfleet_configuration_adas: "ADAS",
    vidfleet_configuration_nav: "NAV",
    vidfleet_configuration_forward_collision_warning: "Forward Collision Warning",
    vidfleet_configuration_headway_monitoring_warning: "Close Following",
    vidfleet_configuration_headway_monitoring_emergency: "Tailgating",
    vidfleet_configuration_lane_departure_warning: "Lane Departure Warning",
    vidfleet_configuration_forward_collision: "Forward Collision",
    vidfleet_configuration_headway_monitoring: "Headway Monitoring",
    vidfleet_configuration_lane_departure: "Lane Departure",
    vidfleet_configuration_following_too_closely: "Following Too Closely",
    vidfleet_configuration_forward_collision_warning_adas: "Collision Warning",
    vidfleet_configuration_headway_monitoring_warning_adas: "Following Too Closely",

    vidfleet_configuration_forward_collision_warning_adas_title: "Forward Collision Warning",
    vidfleet_configuration_headway_monitoring_warning_adas_title: "Headway Monitoring Warning",
    vidfleet_configuration_headway_monitoring_emergency_adas_title: "Headway Monitoring Emergency",

    vidfleet_configuration_following_too_closely_adas: "Following Too Closely",
    vidfleet_configuration_tailgating_adas: "Tailgating",
    vidfleet_configuration_forward_collision_adas: "Collision Warning",
    vidfleet_configuration_message_time_ratio: "Following Distance (time to collision) in Seconds",
    vidfleet_configuration_message_time_ratio_tailgating: "* if enabled, Tailgating is always 50% of the value of Following Too Closely",




    vidfleet_configuration_running_info: "Running Info",
    vidfleet_configuration_interval_in_min: "Interval In Min",

    vidfleet_configuration_advanced: "Advanced",
    vidfleet_configuration_sd_card_event: "Sd Card Event Space",
    vidfleet_configuration_large: "Large",
    vidfleet_configuration_medium: "Medium",
    vidfleet_configuration_small: "Small",

    vidfleet_configuration_time_ratio: "Time Ratio",

    vidfleet_configuration_video_resolution_main: "Main",
    vidfleet_configuration_video_resolution_high: "High",
    vidfleet_configuration_video_resolution_low: "Low",
    vidfleet_configuration_video_resolution_low_priv: "Low Priv",
    vidfleet_configuration_the_start_time_is_invalid: "The start time is invalid",
    vidfleet_configuration_the_end_time_is_invalid: "The end time is invalid",

    vidfleet_configuration_ignition: "Ignition",
    vidfleet_configuration_virtual_mode: "Virtual Mode",

    vidfleet_configuration_camera_height: "Camera Height",
    vidfleet_configuration_vehicle_width: "Vehicle Width",
    vidfleet_configuration_camera_position_to_center: "Camera Position to Center",

    vidfleet_configuration_left: "Left",
    vidfleet_configuration_center: "Center",
    vidfleet_configuration_right: "Right",
    vidfleet_configuration_meter: "m",

    vidfleet_configuration_sound_dms: "Sound DMS",
    vidfleet_configuration_without_changes: "Without changes",

    vidfleet_configuration_video_streams_reset_to_default: "Video streams reset to default",
    vidfleet_configuration_new_video_streams_options: "Set new video streams options",
    vidfleet_configuration_new_night_vision_options: "Set new night vision options",
    vidfleet_configuration_night_vision_reset_to_default: "Night vision reset to default",

    vidfleet_configuration_night_vision_driving_time: "Night vision driving time",

    vidfleet_configuration_new_auto_snapshot_options: "Set new auto snapshot options",
    vidfleet_configuration_auto_snapshot_reset_to_default: "Auto snapshot reset to default",

    vidfleet_configuration_video_resolution_reset_to_default: "Video resolution reset to default",

    vidfleet_configuration_privacy_mask_reset_to_default: "Privacy mask reset to default",
    vidfleet_configuration_new_privacy_mask_options: "Set new privacy mask",

    vidfleet_configuration_volume_reset_to_default: "Volume reset to default",
    vidfleet_configuration_new_volume_options: "Set new volume",

    vidfleet_configuration_obdii_reset_to_default: "OBDII reset to default",
    vidfleet_configuration_new_obdii_options: "Set new OBDII",

    vidfleet_configuration_ignition_reset_to_default: "Ignition reset to default",
    vidfleet_configuration_new_ignition_options: "Set new ignition option",

    vidfleet_configuration_advanced_reset_to_default: "Advanced reset to default",
    vidfleet_configuration_new_advanced_options: "Set new advanced option",

    vidfleet_configuration_dms_reset_to_default: "DMS reset to default",
    vidfleet_configuration_new_dms_options: "Set new DMS option",

    vidfleet_configuration_threshold: "Threshold",

    vidfleet_configuration_options_changed: "Configuration options that are going to be modified or added:",

    vidfleet_configuration_event_level_to_default: "Event Level reset to default",
    vidfleet_configuration_new_event_level_options: "Set new Event Level options",

    vidfleet_configuration_invalid_night_vision_time: "Tiempo de vision nocturna no es valido",

    vidfleet_configuration_video_resolution_front_only: "Front Only",
    vidfleet_configuration_video_resolution_incabin_dms: "InCabin DMS",

    vidfleet_configuration_video_resolution_front_only_message: "When 'Front Only' is selected, DMS monitoring will not be function",

    vidfleet_configuration_headway_monitoring_warning_label: "*Enables both Close Following and Tailgating",
    vidfleet_configuration_headway_monitoring_emergency_label: "*Enables Tailgating only",

    vidfleet_configuration_change_history: "Change History",

    vidfleet_configuration_lang: "Language",
    vidfleet_configuration_english: "English",
    vidfleet_configuration_spanish: "Spanish",

    vidfleet_configuration_config_upload_mode: "Configure Upload Mode",

    vidfleet_configuration_level: "Level",
    vidfleet_configuration_off: "Off",
    vidfleet_configuration_lite: "Lite",
    vidfleet_configuration_standard: "Standard",

    vidfleet_configuration_na: "NA (No Aux)",
    vidfleet_configuration_ecm01: "ECM01 (DMS Sensor)",
    vidfleet_configuration_ecm02: "ECM02 (AUX Camera)",
    vidfleet_configuration_ecm03: "ECM03 (AUX Camera)",

    vidfleet_configuration_aux: "Aux Camera",
    vidfleet_configuration_model: "Model",
    vidfleet_configuration_angle: "Angle",
    vidfleet_configuration_model2: "Model 2",
    vidfleet_configuration_angle2: "Angle 2",

    vidfleet_configuration_angle_normal: "Normal",
    vidfleet_configuration_angle_upsidedown: "Upside Down",
    vidfleet_configuration_angle_rotate_right: "Rotate Right",
    vidfleet_configuration_angle_rotate_left: "Rotate Left",

    vidfleet_configuration_select_aux_camera: "*If the camera has the optional Aux camera installed, the Low or Main profile must be selected",
    vidfleet_configuration_dms_level_off: "*No DMS",
    vidfleet_configuration_dms_level_lite: "*DMS over the mainbody camera, supporting types of USING_PHONE, DISTRACTED, NO_SEATBELT, YAWN",
    vidfleet_configuration_dms_level_standard: "*DMS over the optional separate/external camera supporting all the DMS event type",
    vidfleet_configuration_adas_level_off: "*No ADAS",
    vidfleet_configuration_adas_level_standard: "*Support types of FORWARD_COLLISION, HEADWAY_MONITORING, LANE_DEPARTURE",
    vidfleet_configuration_combination_not_allowed: "The combination of recordConfig / adasLevel / dmsLevel / auxModel / privacyControl is not allowed",

    vidfleet_configuration_message_available_combinations: "Click to see the available combinations",

    vidfleet_configuration_repetead_on_the_list: "Device repeated on the list",
    vidfleet_configuration_device_model: "Model",
    vidfleet_configuration_only_vidfleet_devices: "Only Vidfleet devices",
    vidfleet_configuration_device_not_found: "Device not found",
    vidfleet_configuration_incomplete_status: "Status Imcomplete",
    vidfleet_configuration_search_criteria: "Enter a serial",
    vidfleet_configuration_add: "Add",

    vidfleet_configuration_error_200: "Camera password error",
    vidfleet_configuration_error_201: "camera operation failed",
    vidfleet_configuration_error_202: "Camera does not exist",
    vidfleet_configuration_error_204: "Sync camera error",
    vidfleet_configuration_error_24: "Not authorized",
    vidfleet_configuration_error_23: "Authentication failed",
    vidfleet_configuration_empty: "Please select a feature before send the configuration",
    vidfleet_configuration_verification_code: "Verification Code",
    vidfleet_configuration_send_verification_code: "Send Verification Code",
    vidfleet_configuration_vf_code_sent: "A security code, has been send to your email",
    vidfleet_configuration_vf_code_error: "The security code could not be send to your email",
    vidfleet_configuration_cev: "Cloud Event Validation (CEV)",
    vidfleet_configuration_cev_no_seatbelt: "No Seatbelt",
    vidfleet_configuration_cev_using_phone: "Using Phone",
    vidfleet_configuration_cev_no_driver: "No Driver",
    vidfleet_configuration_cev_passengers_no_seatbelt: "Passengers No Seatbelt",
    vidfleet_configuration_cev_smoking: "Smoking",
    vidfleet_configuration_cev_potential_incident: "Potential Incident",
    vidfleet_configuration_cev_using_phone_warning: "CEV is skipped for Using Phone events when the camera's privacy control blurs faces or its record configuration is Front Only.",
    vidfleet_configuration_cev_events: "Events",
    vidfleet_configuration_disabled: "Disabled",
    vidfleet_configuration_timezone: "Time Zone",
    vidfleet_configuration_timezone_offset: "Offset",
    vidfleet_configuration_timezone_label: "Time Zone",
    vidfleet_configuration_timezone_by: "Time Zone selected by",
    vidfleet_configuration_timezone_subtitle: "Subtitle",
    vidfleet_configuration_stop_sign_violation: "Stop Sign Violation",
    vidfleet_configuration_advanced_parking_heart_beat: "Parking Heart Beat",
    vidfleet_configuration_idle_no_driver: "Idle No Driver",
    vidfleet_configuration_aux_camera_disable: "* this feature is disable, check if the firmware is updated and greater or equal than 2.30.179.48.476",
    vidfleet_configuration_options_default: "The configuration to apply will be the default configuration",
    vidfleet_configuration_label_options: "Configuration Label List",
    vidfleet_configuration_json_options: "Configuration JSON options",
    vidfleet_configuration_safety_assistance: "Safety Assistance",
    vidfleet_configuration_duration: "Duration",
    vidfleet_configuration_speeding: "Speeding",
    vidfleet_configuration_privacy_control: "Privacy Control",
    vidfleet_configuration_none: "None",
    vidfleet_configuration_in_cabin: "In Cabin",
    vidfleet_configuration_passenger: "Passenger",
    vidfleet_configuration_driver: "Driver",
    vidfleet_configuration_permission_message: "Permission is required to modify thresholds",
    vidfleet_configuration_view_restrictions: "View Restrictions",
    vidfleet_configuration_speed: "Speed",
    vidfleet_configuration_subtitle: "Subtitle",
    vidfleet_configuration_disable: "Disable",
    vidfleet_configuration_live_photo: "Live Photo",
    vidfleet_configuration_config_hubspot: "Configure HotSpot",
    vidfleet_configuration_subtitle_timezone_gtmz: "GMT%z",
    vidfleet_configuration_subtitle_timezone_name: "name",
    vidfleet_configuration_gps: "GPS",
    vidfleet_configuration_driver_id: "Driver ID",
    vidfleet_configuration_upload_face: "Upload Face",
    vidfleet_configuration_data_upload: "Data Upload",
    vidfleet_configuration_upload_interval: "Upload Interval",
    vidfleet_configuration_upload_mode: "Upload Mode",
    vidfleet_configuration_upload_mode_hybrid: "Hybrid",
    vidfleet_configuration_upload_mode_default: "Default",
    vidfleet_configuration_upload_mode_hybrid_msg: "The OBDII information will be included into TripInfo package",
    vidfleet_configuration_upload_face_helper: "When activated this trigger face recognition events activating the “auto login/logout” feature",
    vidfleet_configuration_auto_mode: "Auto Mode",
    vidfleet_configuration_passengers_inside: "Passengers Inside",
    vidfleet_configuration_over_max_speeding:"Over Max Speeding",
    vidfleet_configuration_passengers_no_seatbelt: "Passengers No Seatbelt",
    vidfleet_configuration_pedestrian_collision: "Pedestrian Collision",
    vidfleet_configuration_cyclist_collision: "Cyclist Collision",
    vidfleet_configuration_navigation: "Navigation",
    vidfleet_configuration_count: "Count",
    vidfleet_configuration_count_msg: "Number of times of this behavior to report",
    vidfleet_configuration_over_max_speed:"Over Max Speed",
    vidfleet_configuration_pedestrian: "Pedestrian",
    vidfleet_configuration_cyclist: "Cyclist",
    vidfleet_configuration_acceleration: "Acceleration",
    vidfleet_configuration_hard_accel: "Hard Acceleration",
    vidfleet_configuration_harsh_accel: "Harsh Acceleration",
    vidfleet_configuration_severe_accel: "Severe Acceleration",
    vidfleet_configuration_hard_brake: "Hard Brake",
    vidfleet_configuration_harsh_brake: "Harsh Brake",
    vidfleet_configuration_severe_brake: "Severe Brake",
    vidfleet_configuration_sharp_turn: "Sharp Turn",
    vidfleet_configuration_harsh_turn: "Harsh Turn",
    vidfleet_configuration_severe_turn: "Severe Turn",
    vidfleet_configuration_event_trigger_msg: "*You can not configure 'Event Trigger' and 'Acceleration' at the same time",
    vidfleet_configuration_enable_event_thumbnail: "Enable Event Thumbnail",
    vidfleet_configuration_trust_acc_msg: "if virtualMode = true，camera uses a hybrid way to determine the ignition on or off, and 'trustAcc' will be ignored. if virtualMode = false, camera uses the old way to determine the ignition on or off, which is subject to the value of 'trustAcc'autoMode is only effective for Air cameras. and if autoMode = true, 'virtualMode' and 'trustAcc' in cloud configuration will be ignored, the camera should switch among the above 3 modes automatically based on some internal logic. if autoMode = false, it will refer to the table above to determine the current ignition mode.",
    vidfleet_configuration_no_configuration_found: "There is no configuration found for this device, please check if the device is registered in the vidFleet platform",
}